import { motion } from "framer-motion";

const ACCENTS = {
  cyan: {
    idle: "border-slate-200 hover:border-cyan-400 hover:shadow-[0_0_18px_rgba(6,182,212,0.35)]",
    selected: "border-cyan-400 bg-cyan-50/60 shadow-[0_0_20px_rgba(6,182,212,0.5)]",
    dot: "bg-cyan-400 shadow-[0_0_8px_rgba(6,182,212,0.8)]",
  },
  pink: {
    idle: "border-slate-200 hover:border-pink-500 hover:shadow-[0_0_18px_rgba(236,72,153,0.35)]",
    selected: "border-pink-500 bg-pink-50/60 shadow-[0_0_20px_rgba(236,72,153,0.5)]",
    dot: "bg-pink-500 shadow-[0_0_8px_rgba(236,72,153,0.8)]",
  },
  yellow: {
    idle: "border-slate-200 hover:border-yellow-400 hover:shadow-[0_0_18px_rgba(234,179,8,0.35)]",
    selected: "border-yellow-400 bg-yellow-50/60 shadow-[0_0_20px_rgba(234,179,8,0.5)]",
    dot: "bg-yellow-400 shadow-[0_0_8px_rgba(234,179,8,0.8)]",
  },
};

const CYCLE = ["cyan", "pink", "yellow"];

export const ChoiceButton = ({ label, index, selected, onClick }) => {
  const accent = ACCENTS[CYCLE[index % CYCLE.length]];
  return (
    <motion.button
      data-testid="survey-choice-button"
      onClick={onClick}
      whileTap={{ scale: 0.96 }}
      initial={{ opacity: 0, y: 18 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.15 + index * 0.07, type: "spring", stiffness: 260, damping: 24 }}
      className={`w-full min-h-[60px] flex items-center gap-3.5 rounded-2xl border-2 bg-white px-5 py-4 text-left transition-colors duration-200 ${
        selected ? accent.selected : accent.idle
      }`}
      style={{ transitionProperty: "border-color, background-color, box-shadow" }}
    >
      <span className={`h-2.5 w-2.5 shrink-0 rounded-full ${accent.dot}`} />
      <span className="font-display text-base font-bold text-slate-900">{label}</span>
    </motion.button>
  );
};
